import { FC } from "react";
import SuggestExperiencePage from "./SuggestExperiencePage";

const SuggestExperienceWrapper: FC = () => {
  return (
    <div>
      <SuggestExperiencePage />
    </div>
  )
}

export { SuggestExperienceWrapper }